<div class="wrapper" [class.custom-scroll]="isDrsite">
  <!--<h5 class="main-title">{{patientpersonalinfo?.PracticeName}}</h5>-->
  <!-- <span class="text-default">Best Practice <span class="small">1 of 12</span> </span> -->
  <div class="container px-0">
    <!-- <div class="main-info">
        Please provide the following information to access the check-in flow.
    </div> -->
    <!--<div class="main-info pb-0 custom-margin-cls font-weight-bold">
      {{patientpersonalinfo?.practice_name}}
    </div>-->
    <div class="px-2">
      <form [formGroup]="appointmentForm">
        <div class="" *ngIf="isShortScreen || isLargeScreen">
          <p class="mb-2 fw-bold form-label">
            {{'Appointment.appointmentType.label' | translate}}<span class="text-danger">*</span>
          </p>
          <ul class="list-inline list-unstyled mb-0 new-symptoms-list" [ngClass]="{'rtl': isRtl}">

            <li class="list-inline-item">
              <div class="custom-control custom-radio">
                <input type="radio" id="office" formControlName="appointmenttype" value="office"
                  (change)="selectAppointmenttype('office')" class="custom-control-input">
                <label style="margin-bottom:0px !important;" class=" cursor-pointer custom-control-label" for="office"
                  [ngClass]="isDrsite ? '' : 'custom-control-label'">
                  {{'Appointment.appointmentType.options.office' | translate}}
                </label>
              </div>
            </li>
            <li class="list-inline-item rd" style="margin-left: 30px;">
              <div class="custom-control custom-radio">
                <input class="custom-control-input" type="radio" id="telehealth" formControlName="appointmenttype"
                  value="telehealth" (change)="selectAppointmenttype('telehealth')">
                <label style="margin-bottom:0px !important;" class="cursor-pointer custom-control-label"
                  [ngClass]="isDrsite ? '' : 'custom-control-label'" for="telehealth">
                  {{'Appointment.appointmentType.options.telehealth' | translate}}
                </label>

              </div>
            </li>
          </ul>
          <div class="mb-2 err" *ngIf="getappointmentForm.appointmenttype.invalid && getappointmentForm.appointmenttype.touched
&& getappointmentForm.appointmenttype.errors!.required">
            {{'Appointment.appointmentType.requiredError' | translate}}
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-4 mt-3" *ngIf="isShortScreen || isLargeScreen">
            <div class="form-group border-bottom mb-2">
              <label class="form-label fw-bold">
                {{'Appointment.provider.label' | translate}}<span class="text-danger">*</span>
              </label>
              <div [ngClass]="{'drsite-theme': isDrsite,
              'normal-theme': !isDrsite,
              'form-select-blue': isDrsite,
              'form-select': !isDrsite}">
                <ng-multiselect-dropdown class="form-control has-search border-0" [placeholder]="'Select Provider'"
                  [data]="providerData" formControlName="provider" (onDeSelect)="onChangeDate()"
                  (onSelect)="onChangeDate()"
                  [settings]="is100Prac ? dropdownSettingsProviderMulti : dropdownSettingsProvider">
                </ng-multiselect-dropdown>
              </div>
            </div>

            <div class="mb-2">
              <span *ngIf="getappointmentForm.provider.invalid && getappointmentForm.provider.touched
            && getappointmentForm.provider.errors!.required" class="err">
                {{'Appointment.provider.requiredError' | translate}}
              </span>
            </div>
          </div>
          <div class="col-md-4 mt-3" *ngIf="isShortScreen || isLargeScreen">
            <div class="form-group border-bottom mb-2">
              <label class="form-label fw-bold">
                {{'RegistrationPage.location.label' | translate}}<span class="text-danger">*</span>
              </label>
              <div [ngClass]="isDrsite ? 'form-select-blue' : 'form-select'">
                <select translate="no" class="form-control border-0" formControlName="location"
                  [ngStyle]="{'border' : getappointmentForm.location.invalid && getappointmentForm.location.touched && getappointmentForm.location.errors!.required ? '1px solid red' : ''}"
                  (change)="onChangeDate()">
                  <option value="" disabled>{{'RegistrationPage.location.placeholder' | translate}}</option>
                  <option *ngFor="let location of providerLocation" [value]="location.locationCode">
                    {{location.locationName}}
                  </option>
                </select>
              </div>
            </div>
            <div class="mb-2">
              <span *ngIf="getappointmentForm.location.invalid && getappointmentForm.location.touched
                           && getappointmentForm.location.errors!.required" class="err">
                {{'RegistrationPage.location.error' | translate}}
              </span>
            </div>
          </div>
          <div class="col-md-4 mt-3" *ngIf="isLargeScreen || isShortScreen">
            <div class="form-group border-bottom mb-2">
              <label class="form-label fw-bold">
                {{'Appointment.reason.label' | translate}}<span class="text-danger">*</span>
              </label>
              <div [ngClass]="isDrsite ? 'form-select-blue' : 'form-select'">
                <select translate="no" class="form-control border-0" formControlName="reason"
                  [ngStyle]="{'border' : getappointmentForm.reason.invalid && getappointmentForm.reason.touched && getappointmentForm.reason.errors!.required ? '1px solid red' : ''}"
                  (change)="onChangeDate()">
                  <option value="" disabled selected>{{'Appointment.reason.selectVisitReason' | translate}}</option>
                  <ng-container *ngIf="appointmentReasonData">
                    <option *ngFor="let reason of appointmentReasonData" [value]="reason.reasonId">
                      {{reason.reasonName}}
                    </option>
                  </ng-container>

                </select>
              </div>
            </div>
            <div class="mb-2">
              <span
                *ngIf="getappointmentForm.reason.invalid && getappointmentForm.reason.touched && getappointmentForm.reason.errors!.required"
                class="err">
                {{'Appointment.reason.requiredError' | translate}}
              </span>
            </div>
          </div>
          <div class="col-12 col-sm-auto mb-sm-0 pl-0 pl-sm-2" *ngIf="!ShowSlotsScreens">
            <button class="btn rounded btn-block mt-4" [ngClass]="isDrsite ? 'blue-btn' : 'btn-primary'"
              (click)="getAppointmentTimeSlot()">
              {{
              'button.search' |
              translate
              }}
            </button>
          </div>
        </div>
      </form>
      <ng-container *ngIf="ShowSlotsScreens && appointmentSlotsLoaded">
        <form [formGroup]="appointmentForm" *ngIf="isShortScreen"
          class="align-items-center d-flex flex-column justify-content-center mb-2  row ">

        </form>

        <ng-container *ngIf="!appointmentSlotsLoaded && !appointmentTimeSlotFlag">
          <!-- Show loader here -->
          <div class="text-center mt-4">
            <mat-spinner diameter="40"></mat-spinner>
            <p>Loading available slots...</p>
          </div>
        </ng-container>
        <div class="align-items-center row p-2 rounded custom-height"
          [ngClass]="isDrsite ? 'bg-c-blue-1' : 'bg-c-grey-l'">

          <div class="m-auto rounded text-center text-md-left checkIn-calendar col-md-12 d-flex justify-content-center">
            <mat-form-field appearance="outline" class="w-auto">
              <h5 class="mb-0 fs-20 fw-bold text-center" (click)="openMonthPicker(monthPicker)">
                {{ selectedMonthName }} &#160;
              </h5>
              <input matInput [matDatepicker]="monthPicker" [min]="minimumDate" hidden>
              <mat-datepicker-toggle matSuffix [for]="monthPicker"></mat-datepicker-toggle>
              <mat-datepicker #monthPicker startView="year" panelClass="month-picker"
                (monthSelected)="chosenMonthHandler($event, monthPicker)">
              </mat-datepicker>
            </mat-form-field>

          </div>

          <div class="col-md-12 col-xl-12">
            <div class="carousel slide "
              [ngClass]="{'date-timecarousel-blue': isDrsite,'date-time-carousel': !isDrsite,}" data-interval="false"
              data-ride="carousel" id="carouselAppointment">
              <div class="carousel-inner text-center">
                <div class="carousel-item active">
                  <div class="mx-lg-5 mx-md-2">
                    <div class="row no-wrap week-calendar">
                      <!-- <div class="custom-width" *ngFor="let reqApp of dSeriesFinal"
                        [ngClass]="{'disabled-date': reqApp.isDisable}"
                        (click)="!reqApp.isDisable && onAppointmentDate(reqApp)"
                        [class.selected-time]="reqApp.isSelected" style="cursor: pointer;">
                        <div
                          [ngClass]="{'custom-date-time-picker-container_blue':isDrsite, 'custom-date-time-picker-container_green': !isDrsite}"
                          class="bg-white ng-star-inserted px-2 py-1 rounded-lg">
                          <p class="custom-font mb-1">{{reqApp.day}}</p>
                          <h5 class="custom-font">{{reqApp.date}}</h5>
                        </div>
                      </div> -->
                      <div class="custom-width" *ngFor="let reqApp of dSeriesFinal"
                        [ngClass]="{'disabled-date': reqApp.isDisable}"
                        (click)="!reqApp.isDisable && onAppointmentDate(reqApp)"
                        [class.selected-time]="reqApp.isSelected" style="cursor: pointer;">

                        <div [ngClass]="{
      'custom-date-time-picker-container_blue': isDrsite,
      'custom-date-time-picker-container_green': !isDrsite
    }" class="bg-white ng-star-inserted px-2 py-1 rounded-lg">

                          <p class="custom-font mb-1">{{ reqApp.day }}</p>
                          <h5 class="custom-font">{{ reqApp.date }}</h5>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <a class="carousel-control-prev carousel-control-custom-prev" data-slide="prev" role="button"
                (click)="previousAppointmentDate()">
                <span aria-hidden="true" class="carousel-control-prev-icon"></span>
                <span class="sr-only">Previous</span>
              </a>
              <a class="carousel-control-next carousel-control-custom-next" data-slide="next" role="button"
                (click)="nextAppointmentDate()">
                <span aria-hidden="true" class="carousel-control-next-icon"></span>
                <span class="sr-only">Next</span>
              </a>
            </div>

          </div>
        </div>

        <div class="d-flex justify-content-end" *ngIf="appointmentTimeSlotFlag == true">
          <div class="form-check mt-2">
            <input class="m-2" type="checkbox" id="firstAvailable" [(ngModel)]="isFirstAvailable"
              (change)="searchAvailable(isFirstAvailable)">
            <label style="font-size:17px" class="form-check-label" for="firstAvailable">
              {{'Appointment.appointmentSlots.first_available' | translate}}
            </label>
          </div>
        </div>

        <div class="schedule-appt-scroll position-relative">

          <ng-container *ngIf="appointmentTimeSlotFlag == true; else notFoundData">
            <div class="flex-wrap border-bottom mt-xl-4 ltr-component"
              *ngFor="let group of groupedSlotsArray; let groupIndex = index; trackBy: trackByFn">

              <!-- Date Header -->
              <!-- <div>
                <h5 class="fw-bold text-center">{{ formatSlotDate(group.date) }}</h5>
              </div> -->

              <!-- All Providers in Same Card -->
              <div class="d-flex flex-wrap border-bottom  mt-xl-4 p-2 rounded row mt-2"
                [ngClass]="isDrsite ? 'bg-c-blue-1' : 'bg-c-grey-l'">
                <div class="w-100">
                  <h5 class="d-flex fw-bold justify-content-center text-center w-100">{{ formatSlotDate(group.date) }}
                  </h5>
                </div>
                <ng-container *ngFor="let providerGroup of group.providers; let providerIndex = index">
                  <!-- Provider Name -->
                  <div class="w-100 mt-1 mb-1" style="margin-left: -10px;">
                    <h5 class="provider-detail w-100 text-center fw-bold">
                      <i class="fa fa-user-md fs-16 text-dark-blue mr-1"></i>
                      {{ providerGroup.providerName }}
                    </h5>
                  </div>

                  <!-- Slots -->
                  <div class="col-12 justify-content-md-center m-auto row w-100 justify-small-center"
                    style="padding-bottom:15px;">
                    <ng-container *ngIf="providerGroup.slots.length > 0; else notFound">
                      <div *ngFor="let sl of providerGroup.slots; let i = index">
                        <ng-container *ngIf="i < 6 || expandedSlots[groupIndex + '-' + providerIndex]">
                          <div class="btn mt-2 rounded time-slot-btn bg-white" [ngClass]="{
                                 'active': isSlotSelected(sl),
                                 'btn-outline-info-blue': isDrsite,
                                 'btn-outline-info': !isDrsite
                               }" (click)="onSelectSlot($event, sl, false)">
                            <!-- <i class="fa fa-clock fs-16 mr-1"></i> -->
                            <i [ngClass]="{ 'blue-clock': isDrsite, 'green-clock': !isDrsite }"
                              class="far fa-clock mr-1"></i>
                            <span>{{ sl.availableSlot }}</span>
                          </div>&nbsp;
                        </ng-container>
                      </div>

                      <!-- More / Less -->
                      <button *ngIf="providerGroup.slots.length > 6 && !expandedSlots[groupIndex + '-' + providerIndex]"
                        type="button" class="btn mt-2 rounded time-slot-btn mr-2 bg-white"
                        [ngClass]="{ 'btn-outline-info-blue': isDrsite, 'btn-outline-info': !isDrsite }"
                        (click)="onClickMore(groupIndex, providerIndex)">
                        More
                      </button>

                      <button *ngIf="providerGroup.slots.length > 6 && expandedSlots[groupIndex + '-' + providerIndex]"
                        type="button" class="btn mt-2 rounded time-slot-btn mr-2 bg-white"
                        [ngClass]="{ 'btn-outline-info-blue': isDrsite, 'btn-outline-info': !isDrsite }"
                        (click)="onClickMore(groupIndex, providerIndex)">
                        Less
                      </button>
                    </ng-container>

                    <!-- No Slots -->
                    <ng-template #notFound>
                      <div class="col-sm-12 text-center">
                        <label style="color: #de2125; font-weight: bold;">No slot is available.</label>
                      </div>
                    </ng-template>
                  </div>
                </ng-container>

                <!-- Waitlist per date -->
                <!-- <div *ngIf="!is100Prac" class="w-100 mt-3 text-center ltr-component">
                  <label>{{ 'Appointment.waitList.cant_find_a_time' | translate }}</label>
                  <a href="javascript:void(0)" (click)="onWaitListClick(group.date)">
                    {{ 'Appointment.waitList.add_to_waitlist' | translate }}
                  </a>
                </div> -->
              </div>
            </div>
          </ng-container>
        </div>
        <ng-template #notFoundData>
          <div class="justify-content-center d-flex flex-wrap border-bottom mt-2 mt-xl-4 p-2 rounded row"
            [ngClass]="isDrsite ? 'bg-c-blue-1' : 'bg-c-grey-l'">
            <label style="color: #de2125; font-weight: bold;">
              {{
              'Appointment.appointmentSlots.no_slots_available' |
              translate
              }}
            </label>
          </div>
        </ng-template>

      </ng-container>

      <ngx-spinner [fullScreen]="true" name="timeslots" bdColor="rgba(232,238,243,0.61)"  size="large"  color="#103b72"
         type="ball-spin"></ngx-spinner>
    </div>
  </div>

</div>
<div class="modal fade in modal-alert bd-example-modal-sm" id="noLabWorkModal" tabindex="-1" role="dialog"
  data-backdrop="static" data-keyboard="false">

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger"><strong> {{'Alerts.lab_work'|translate}}</strong></h5>
        <p class="mb-3">{{'Alerts.lab_work_popup_body'|translate}}</p>
        <div class="text-center">
          <button type="button" data-toggle="modal" data-dismiss="modal"
            [ngClass]="isDrsite ? 'btn blue-btn' : 'btn btn-primary'">
            {{'button.ok'|translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<footer class="p-3" *ngIf="!isLargeScreen">
  <div class="container p-0">
    <div class="d-flex justify-content-between align-items-center">
      <button class="btn" type="button"
        [ngClass]="{'blue-btn-outline': isDrsite,'btn-outline-primary': !isDrsite,'v-hidden':!ShowSlotsScreens}"
        (click)="backPage()">
        {{'button.back'|translate}}
      </button>
      <!-- <p class="mb-0">(4 of 7)</p> -->
      <button class="btn " type="button" [ngClass]="isDrsite ? 'blue-btn' : 'btn-primary'"
        (click)="ShowSlotsScreens ? SelectPatientOption('walkin') : getAppointmentTimeSlot()">
        {{'button.next'|translate}}
      </button>

    </div>
  </div>
</footer>

<footer class="p-3" *ngIf="isLargeScreen">
  <div class="container p-0">
    <div class="d-flex justify-content-between align-items-center">
      <button class="btn btn-primary v-hidden pointer-none" type="button">{{'button.back'|translate}}</button>
      <button class="btn " type="button" [ngClass]="isDrsite ? 'blue-btn' : 'btn-primary'"
        (click)="ShowSlotsScreens ? SelectPatientOption('walkin') : getAppointmentTimeSlot()">
        {{'button.next'|translate}}
      </button>
    </div>
  </div>
</footer>